import SHA1 from "crypto-js/sha1";

export const TagGroupType = {
	Card: "CA",
	Wristband: "WR",
	Other: "OT"
};

/** TagGroup.
 *
 * @param {Object} params - Object parameter
 * @param {string} params.batch_id - Unique batch identifier
 * @param {string} params.name - Name of the tag group
 * @param {string} params.type - Type of the tag group
 * @param {string} params.color - Hexadecimal color code
 * @param {integer} params.event_id - Associated event ID
 * @param {integer} params.organizer_id - Organizer ID
 * @param {integer} params.quantity - Quantity of the tag group
 * @constructor
 */
export default class TagGroup {
	constructor({
		batch_id,
		name,
		event_name,
		type,
		color,
		event_id,
		organizer_id,
		quantity,
		created_at,
		updated_at
	} = {}) {
		this.batch_id = batch_id;
		this.name = name;
		this.event_name = event_name;
		this.type = type;
		this.color = color;
		this.event_id = event_id;
		this.organizer_id = organizer_id;
		this.quantity = quantity;
		this.created_at = created_at;
		this.updated_at = updated_at;
	}

	spreadBlockData(blockData) {
		let spreadKeys = [
			"batch_id",
			"name",
			"event_name",
			"type",
			"color",
			"event_id",
			"organizer_id",
			"quantity"
		];
		spreadKeys.forEach(key => (this[key] = blockData[key]));
	}

	getBlockHash() {
		let {
			batch_id,
			name,
			event_name,
			type,
			color,
			event_id,
			organizer_id,
			quantity
		} = this;

		let hashKey =
			(batch_id ? batch_id : "B") +
			(name ? name : "N") +
			(event_name ? event_name : "E") +
			(type ? type : "T") +
			(color ? color : "C") +
			(event_id ? event_id : "EI") +
			(organizer_id ? organizer_id : "O") +
			(quantity ? quantity : "Q");

		return SHA1(hashKey).toString();
	}

	batchId() {
		return this.batch_id;
	}
	name() {
		return this.name;
	}
	event_name() {
		return this.event_name;
	}
	type() {
		return this.type;
	}
	color() {
		return this.color;
	}
	eventId() {
		return this.eventId;
	}
	organizerId() {
		return this.organizerId;
	}
	quantity() {
		return this.quantity;
	}
}
